import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, useState, useRef } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import TableActiveComponent from "./Components/TablePrimaryComponent";

const IndexView = (props) => {
  const [activeTab, setactiveTab] = useState("1");
  const activeRef = useRef();
  const inactiveRef = useRef();

  const reloadActiveRef = () => activeRef.current.setTokenAPI();
  const reloadInactiveRef = () => activeRef.current.setTokenAPI();

  function toggle(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  }

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card className="">
              <CardBody>
                <CardTitle>Daftar Pemberhentian Pegawai</CardTitle>
                <CardSubtitle className="mb-3">
                  Kelola Daftar Pemberhentian Pegawai
                </CardSubtitle>
                <hr />
                <TableActiveComponent
                  ref={activeRef}
                  handleInactiveSuccess={reloadInactiveRef}
                />
                <br />
                <div>
                  <Link to="/kepegawaian/pensiun.html">
                    <Button color="success">
                      <i className="uil-backspace"></i> Kembali
                    </Button>
                  </Link>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default IndexView;
